<template>
  <div class="cloudPhoneSetup pointer">
    <NavBar title="云手机设置" />

    <div class="main">
      <div class="setting-item">
        <div class="item">
          <van-cell-group>
            <van-switch-cell
              v-model="isMic"
              title="允许云手机请求使用我的麦克风"
              @change="update"
            />
          </van-cell-group>
        </div>
        <div class="item">
          <van-cell-group>
            <van-switch-cell
              v-model="isCamera"
              title="允许云手机请求使用我的摄像头"
              @change="update"
            />
          </van-cell-group>
        </div>
        <div class="item">
          <van-cell-group>
            <van-switch-cell
              v-model="isVoice"
              title="允许播放云手机声音"
              @change="update"
            />
          </van-cell-group>
        </div>
      </div>
      <!-- <div class="setting-item">
        <div class="item">
          <van-cell-group>
            <van-switch-cell
              v-model="isFull"
              title="满屏显示云手机"
              @change="update"
            />
          </van-cell-group>
        </div>
        <div class="item">
          <div class="fastCopyBox">
            <div class="copyName">
              <span>快捷复制</span
              ><img
                @click="mayMoney"
                class="mayIcon"
                src="@/assets/icons/hint.png"
                alt=""
              />
            </div>
            <van-switch
              v-model="checkedCopy"
              size="24px"
              @change="changeCopy"
            />
          </div>
        </div>
        <div class="item">
          <van-cell
            title="默认清晰度"
            is-link
            :value="nowdata.text"
            title-class="cellTitle"
            value-class="cellValue"
            @click="pixelClick"
            class="sharpnessBox"
          />
        </div>
        <div class="item">
          <div class="fastCopyBox">
            <div class="copyName">
              <span>切换后退出设备</span
              ><img
                @click="cutQuitHint"
                class="mayIcon"
                src="@/assets/icons/hint.png"
                alt=""
              />
            </div>
            <van-switch
              v-model="cutQuit"
              size="24px"
              @change="cutQuitEquipment"
            />
          </div>
        </div>
      </div>
      <div class="setting-item">
        <div class="item">
          <van-cell-group>
            <van-switch-cell
              v-model="isFloatAdsorb"
              title="全屏时功能按钮自动吸附"
              @change="upDateFloatAdsorb"
            />
          </van-cell-group>
        </div>
        <div class="item cellBox">
          <van-cell title="云手机预览刷新速度" title-class="cellTitle">
            <template #right-icon>
              <div class="refreshActiveBox">
                <div class="refreshActive">
                  <div
                    :class="['slow', refreshSpeed == 2000 ? 'activeSpeed' : '']"
                    @click="refreshSpeedFun(2000)"
                  >
                    较慢
                  </div>
                  <div
                    :class="[
                      'normal',
                      refreshSpeed == 1000 ? 'activeSpeed' : '',
                    ]"
                    @click="refreshSpeedFun(1000)"
                  >
                    正常
                  </div>
                  <div
                    :class="['fast', refreshSpeed == 500 ? 'activeSpeed' : '']"
                    @click="refreshSpeedFun(500)"
                  >
                    较快
                  </div>
                </div>
              </div>
            </template>
          </van-cell>
        </div>
      </div>
      <div class="draggableBox cellBox">
        <div class="draggableTitle">侧边栏显示(拖拽可编辑显示顺序)</div>
        <draggable
          v-model="menuResult"
          :options="{ group: 'menu' }"
          class="draggableList"
          @update="locationUpdate"
        >
          <div v-for="item in menuResult" :key="item.text">
            <van-checkbox
              v-model="item.checked"
              @change="menuChange"
              checked-color="#8572eb"
              >{{ item.text }}</van-checkbox
            >
          </div>
        </draggable>
      </div> -->
    </div>
    <van-popup v-model="pixelShow" closeable>
      <div class="pixelbox">
        <div class="titxt">默认清晰度</div>
        <div
          v-for="item in pixeldata"
          :key="item.value"
          class="pixelList"
          @click="optFor(item)"
        >
          <div>
            {{ item.text }}
          </div>
          <div class="atPresentBox">
            <img
              v-show="nowdata.value == item.value"
              class="atPresent"
              src="@/assets/icons/atPresent.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </van-popup>
    <dialogHint
      :dialogShow="dialogShow"
      :dialogTitle="dialogTitle"
      @dialogClic="confirms"
    >
      <template v-slot:content>{{ dialogContent }}</template>
    </dialogHint>
    <detainmentDialog
      v-model="showDialog"
      width="298"
      confimText="确认"
      cancelText="取消"
      cancelType="primary"
      :confimBtnLoading="confimBtnLoading"
      @confim="confirmModel"
      @change="changeModel"
      title="提示"
    >
      <div class="contentBox">
        未连接WiFi的情况下，较快的云手机预览刷新速度将会加剧手机流量的消耗，是否确认修改？
      </div>
    </detainmentDialog>
  </div>
</template>
  
  <script>
import { userinfo, update } from "@/api/index.js";
import NavBar from "@/components/NavBar.vue";
import dialogHint from "@/components/publicDialog/dialogHint.vue";
import detainmentDialog from "@/components/publicDialog/detainmentDialog.vue";
import { Toast } from "vant";
import draggable from "vuedraggable";
import { setData } from "@/utils/auth";
import { mapMutations } from "vuex";
export default {
  name: "CloudPhoneSetup",
  components: {
    NavBar,
    dialogHint,
    detainmentDialog,
    draggable,
  },
  data() {
    return {
      isMic: false,
      isCamera: false,
      isVoice: false,
      isFull: false,
      userinfos: {},
      pixelShow: false,
      pixeldata: [
        {
          value: -1,
          text: "自动",
        },
        {
          value: 0,
          text: "流畅",
        },
        {
          value: 1,
          text: "标清",
        },
        {
          value: 2,
          text: "高清",
        },
      ],
      nowdata: {
        value: -1,
        text: "自动",
      },
      checkedCopy: false,
      dialogShow: false,
      dialogTitle: "",
      dialogContent: "",
      refreshSpeed: 2000,
      showDialog: false,
      confimBtnLoading: false,
      isFloatAdsorb: false,
      // items: ["全屏", "剪切板", "客服", "续时", "重启"],
      menuResult: [],
      cutQuit: false,
    };
  },

  mounted() {
    this.userinfos = JSON.parse(this.$store.getters.data);
    this.getuserinfo();
    // let _wholePixel = JSON.parse(localStorage.getItem("wholePixel"));
    // if (_wholePixel || _wholePixel == 0) {
    //   this.pixeldata.forEach((item) => {
    //     if (item.value == _wholePixel) {
    //       this.nowdata = item;
    //     }
    //   });
    // }
    // let _fastCopy = JSON.parse(localStorage.getItem("fastCopy"));
    // if (_fastCopy != null) {
    //   this.checkedCopy = _fastCopy;
    // } else {
    //   this.checkedCopy = true;
    // }
    // let _refreshSpeed = JSON.parse(localStorage.getItem("refreshSpeed"));
    // if (_refreshSpeed != null) {
    //   this.refreshSpeed = _refreshSpeed;
    // }
    // let _isFloatAdsorb = JSON.parse(localStorage.getItem("isFloatAdsorb"));
    // if (_isFloatAdsorb != null) {
    //   this.isFloatAdsorb = _isFloatAdsorb;
    // }
    // let _cutQuit = JSON.parse(localStorage.getItem("cutQuit"));
    // if (_cutQuit == null) {
    //   this.cutQuit = true;
    // } else {
    //   this.cutQuit = _cutQuit;
    // }
    // let _menuResult = JSON.parse(localStorage.getItem("menuResult"));
    // if (_menuResult) {
    //   this.menuResult = _menuResult;
    // } else {
    //   this.menuResult = [
    //     {
    //       checked: true,
    //       text: "全屏",
    //       src: require("@/assets/icons/fullScreenImg.png"),
    //     },
    //     {
    //       checked: true,
    //       text: "快捷切换",
    //       src: require("@/assets/icons/last.png"),
    //     },
    //     {
    //       checked: true,
    //       text: "剪切板",
    //       src: require("@/assets/icons/shearPlateImg.png"),
    //     },
    //     {
    //       checked: true,
    //       text: "客服",
    //       src: require("@/assets/icons/serviceImg.png"),
    //     },
    //     {
    //       checked: true,
    //       text: "续时",
    //       src: require("@/assets/icons/continueImg.png"),
    //     },
    //     {
    //       checked: true,
    //       text: "重启",
    //       src: require("@/assets/icons/restartImg.png"),
    //     },
    //   ];
    // }
  },
  computed: {},

  methods: {
    ...mapMutations("user", ["SET_DATA"]),
    // 查询用户信息
    async getuserinfo() {
      await userinfo().then((res) => {
        if (res.code == 200) {
          this.userinfos.isVoice = res.data.isVoice;
          this.userinfos.isMic = res.data.isMic;
          this.userinfos.isCamera = res.data.isCamera;
          this.userinfos.isFull = res.data.isFull;
          this.isVoice = res.data.isVoice == 0 ? false : true;
          this.isMic = res.data.isMic == 0 ? false : true;
          this.isCamera = res.data.isCamera == 0 ? false : true;
          this.isFull = res.data.isFull == 0 ? false : true;
        } else {
          Toast(res.msg);
        }
      });
    },
    // 修改用户信息
    async update() {
      let data = {
        isVoice: this.isVoice ? 1 : 0,
        isMic: this.isMic ? 1 : 0,
        isCamera: this.isCamera ? 1 : 0,
        isFull: this.isFull ? 1 : 0,
      };
      await update(data).then((res) => {
        if (res.code == 200) {
          Toast(res.msg);
          setData(this.userinfos);
          this.SET_DATA(JSON.stringify(this.userinfos));
        }
      });
    },
    pixelClick() {
      this.pixelShow = true;
    },
    optFor(item) {
      this.nowdata = item;
      this.pixelShow = false;
      localStorage.setItem("wholePixel", JSON.stringify(item.value));
      Toast("操作成功");
    },
    mayMoney() {
      this.dialogTitle = "快捷复制";
      this.dialogContent =
        "该快捷复制打开状态下，可识别本地剪切板，将自己手机内容直接复制到云手机内。关闭状态下，只能通过剪切板复制到云手机。";
      this.dialogShow = true;
    },
    cutQuitHint() {
      this.dialogTitle = "切换后退出设备";
      this.dialogContent =
        "打开后本地切换软件将自动退出云手机，返回预览界面（注：关闭状态下切换会持续消耗流量）";
      this.dialogShow = true;
    },
    confirms(msg) {
      this.dialogShow = msg;
    },
    changeCopy(e) {
      localStorage.setItem("fastCopy", JSON.stringify(e));
    },
    cutQuitEquipment(e) {
      localStorage.setItem("cutQuit", JSON.stringify(e));
    },
    refreshSpeedFun(num) {
      if (num != this.refreshSpeed) {
        if (num != this.refreshSpeed && num != 500) {
          this.refreshSpeed = num;
          localStorage.setItem("refreshSpeed", this.refreshSpeed);
        } else if (num == 500) {
          this.showDialog = true;
        }
      }
    },
    confirmModel() {
      this.refreshSpeed = 500;
      localStorage.setItem("refreshSpeed", this.refreshSpeed);
      this.showDialog = false;
    },
    changeModel() {
      this.showDialog = false;
    },
    // 本地储存全屏时功能按钮自动吸附
    upDateFloatAdsorb() {
      localStorage.setItem("isFloatAdsorb", this.isFloatAdsorb);
    },
    // groupChange(checked) {
    //   localStorage.setItem("menuResult", this.menuResult);
    // },
    menuChange(checked) {
      localStorage.setItem("menuResult", JSON.stringify(this.menuResult));
    },
    locationUpdate() {
      localStorage.setItem("menuResult", JSON.stringify(this.menuResult));
    },
  },
};
</script>
  
  <style lang="less" scoped>
.cloudPhoneSetup {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.main {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: manipulation;
  scrollbar-width: none;
  padding: 10px 16px;
  .setting-item {
    width: 100%;
    background: #fff;
    border-radius: 10px;
    color: #333;
    font-size: 14px;
    padding: 0 16px;
    margin-bottom: 12px;
    .item {
      width: 100%;
      // height: 56px;
    }
    .item:not(:last-child) {
      border-bottom: 1px solid #e6e6e6;
    }
    .cellBox {
      border-top: 1px solid #f4f5f9;
      // border-bottom: 1px solid #f4f5f9;
      .cellTitle {
        line-height: 40px;
      }
      .cellValue {
        line-height: 40px;
      }
      .refreshActiveBox {
        height: 40px;
        display: flex;
        align-items: center;
      }
      .refreshActive {
        display: flex;
        align-items: center;
        height: 25px;
        line-height: 25px;
        font-size: 10px;
        background-color: #eaecee;
        border-radius: 5px;
        .slow {
          width: 50px;
          height: 25px;
          border-bottom-left-radius: 5px;
          border-top-left-radius: 5px;
        }
        .normal {
          width: 50px;
          height: 25px;
        }
        .fast {
          width: 50px;
          height: 25px;
          border-bottom-right-radius: 5px;
          border-top-right-radius: 5px;
        }
        .activeSpeed {
          background-color: #8572eb;
          color: #fff;
        }
      }
      .van-cell__right-icon {
        margin-top: 8px;
      }
    }
  }
}
.ul_setting {
  // margin-top: 32px;
  // height: 194px;
  background: #ffffff;
  li {
    height: 60px;
  }
  .checklis {
    border-top: 1px solid #f4f5f9;
    border-bottom: 1px solid #f4f5f9;
  }
}
.cloudphone {
  margin-top: 10px;
}
/deep/ .van-hairline--top-bottom::after {
  border: none;
}
/deep/ .van-cell {
  height: 60px;
  padding: 0;
  align-items: center;
  .van-cell__title {
    text-align: left;
    flex: 2;
  }
}

.van-popup {
  width: 80%;
  border-radius: 10px;
}
.pixelbox {
  overflow: hidden;
  .titxt {
    height: 52px;
    line-height: 52px;
    font-size: 18px;
  }
  .pixelList {
    border-top: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    .atPresentBox {
      display: flex;
      align-items: center;
      justify-content: center;
      .atPresent {
        width: 20px;
        // margin-top: 10px;
      }
    }
    & > div {
      width: 80px;
    }
  }
}
.sharpnessBox {
  display: flex;
  align-items: center;
}
.fastCopyBox {
  height: 60px;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .van-switch {
    // margin-right: 15px;
  }
  .copyName {
    // margin-left: 15px;
    display: flex;
    .mayIcon {
      width: 20px;
    }
  }
}
.contentBox {
  font-size: 14px;
  padding: 0 10px;
}
.draggableBox {
  background-color: #fff;
  padding: 10px 16px;
  margin-bottom: 20px;
  border-radius: 10px;
  .draggableTitle {
    font-size: 14px;
    color: #323233;
    text-align: left;
  }
}
.draggableList {
  display: grid;
  grid-template-columns: auto auto auto auto;
  row-gap: 8px;
  column-gap: 8px;
  box-sizing: border-box;
  margin-top: 24px;
  /deep/.van-checkbox__label {
    margin-left: 2px;
  }
}
/deep/.van-switch--on {
  background-color: #8572eb;
}
</style>